import { createAsyncTypes } from 'utils/ActionCreator'

export const RUN_VISUAL_SCAN_ASYNC = createAsyncTypes('RUN_VISUAL_SCAN', 'Dashboard/VISUALSCAN')
export const FETCH_IMAGE_ASYNC = createAsyncTypes('FETCH_IMAGE', 'Dashboard/VISUALSCAN/FETCH_IMAGE')
